<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <h1>
                Sips: {{drinks}}
            </h1>
        </v-row>
        <v-row align="center" justify="center">
            <div class="card">
                <h2>{{leftCardValue}}</h2>
                <h2>{{suits[suitsIndex]}}</h2>
            </div>
            <div class="card" v-bind:class="{ 'back': back }">
                <h2>{{rightCardValue}}</h2>
                <h2>{{suits[secondSuitsIndex]}}</h2>
            </div>
        </v-row>
        <v-row align="center" justify="center">
            <v-btn x-large class="button" color="success" @click="submitHigher">Higher</v-btn>
            <v-btn x-large class="button" color="error" @click="submitLower">Lower</v-btn>
        </v-row>
        <v-row>
            <v-dialog
                    v-model="dialog"
                    max-width="290"
                    persistent
            >
                <v-card>
                    <v-card-title class="headline, justify-center" v-if="!this.save">YIKES!</v-card-title>
                    <v-card-title class="headline, justify-center" v-if="this.save">Save Highscore</v-card-title>

                    <v-card-text class="text-center" v-if="this.save">
                        <v-text-field
                                v-model="name"
                                label="Name"
                                placeholder="Type in your name."
                        ></v-text-field>
                    </v-card-text>
                    <v-card-text class="text-center" v-if="!this.save">
                        Drink {{drinks}} sips!
                    </v-card-text>

                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn
                                color="green darken-1"
                                text
                                @click="saveHighscore"
                                v-if="!this.save"
                        >
                            Save
                        </v-btn>
                        <v-btn
                                color="green darken-1"
                                text
                                @click="submitHighscore"
                                v-if="this.save"
                        >
                            Submit
                        </v-btn>
                        <v-btn
                                color="green darken-1"
                                text
                                @click="resetGame"
                        >
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
    import {highscoresCollection} from "../../firebase";

    export default {
        name: 'Card',
        data() {
            return {
                value: ['A', 2, 3, 4, 5, 6, 7, 8, 9, 10, 'B', 'Q', 'K'],
                suits: ['♠', '♥', '♦', '♣'],

                suitsIndex: '',
                secondSuitsIndex: '',

                leftCardValue: '',
                leftCardIndex: '',

                rightCardValue: '',
                rightCardIndex: '',

                drinks: 0,
                dialog: false,

                back: true,

                save: false,
                name: '',
            };
        },
        methods: {

            getRandomValueIndex() {
                return Math.floor(Math.random() * 13);
            },

            getRandomSuitsIndex() {
                return Math.floor(Math.random() * 4);
            },

            submitHigher() {
                const flippedCard = this.getRandomValueIndex();

                if (this.leftCardIndex <= flippedCard) {
                    this.leftCardIndex = flippedCard;
                    this.leftCardValue = this.value[flippedCard];
                    this.drinks++;
                    this.suitsIndex = this.getRandomSuitsIndex();
                } else {
                    this.back = false;
                    this.rightCardValue = this.value[flippedCard];
                    this.secondSuitsIndex = this.getRandomSuitsIndex();
                    this.endGame();
                }
            },

            submitLower() {
                const flippedCard = this.getRandomValueIndex();

                if (this.leftCardIndex >= flippedCard) {
                    this.leftCardIndex = flippedCard;
                    this.leftCardValue = this.value[flippedCard];
                    this.drinks++;
                    this.suitsIndex = this.getRandomSuitsIndex();
                } else {
                    this.back = false;
                    this.rightCardValue = this.value[flippedCard];
                    this.secondSuitsIndex = this.getRandomSuitsIndex();
                    this.endGame();
                }
            },
            endGame() {
                this.dialog = true;
            },

            resetGame() {
                this.drinks = 0;
                this.name = '';
                this.dialog = false;
                this.save = false;
                this.setupGame();
            },

            setupGame() {
                this.leftCardIndex = this.getRandomValueIndex();
                this.leftCardValue = this.value[this.leftCardIndex];
                this.rightCardValue = '';
                this.rightCardIndex = '';
                this.suitsIndex = this.getRandomSuitsIndex();
                this.secondSuitsIndex = '';
                this.back = true;
            },

            saveHighscore() {
                this.save = true;
            },

            submitHighscore() {
                highscoresCollection.add({name: this.name, score: this.drinks});
                this.resetGame();
            },
        },
        mounted() {
            this.setupGame();
        },
    };
</script>

<style scoped>

    h1 {
        margin-top: 2em;
    }

    .card {
        width: 5em;
        height: 7em;
        padding: 10px;
        border: solid 1px #808080;
        background-color: white;
        display: inline-block;
        border-radius: 10px;
        font-size: 20pt;
        text-align: center;
        color: black;
        margin-top: 2em;
        margin-right: 5px;
        margin-left: 5px;
    }

    .back {
        background-image: url("cardBack.png");
        background-size: cover;
    }

    .button {
        margin-top: 2em;
        margin-right: 5px;
        margin-left: 5px;
        width: 7em;
    }

</style>